import { ApolloProvider } from "@apollo/client";
import { Layer } from "@carbon/react";
import {
  AuthModeProvider,
  ImportExportAuthGuard,
  InternationalizationProvider as ImportExportInternationalizationProvider,
  JobsListPage,
} from "@flaminem/import-export";
import { useNavigate } from "react-router-dom";

import { AppUser } from "src/authentication/appUser.ts";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { getImportExportApolloClient } from "src/graphql/import-export/apolloClient.ts";
import { useLocale, useT } from "src/internationalization";

export const JobsPage = () => {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const t = useT();

  return (
    <ApolloProvider client={getImportExportApolloClient()}>
      <AuthModeProvider authMode="bearer">
        <ImportExportAuthGuard getToken={() => AppUser.getAccessToken() ?? null}>
          <ImportExportInternationalizationProvider locale={locale}>
            <PageStack>
              <PageHeader className="mb-5">{t("import.jobs.title")}</PageHeader>
              <Layer level={1}>
                <JobsListPage isFraudMode onClick={(jobId) => navigate(`/jobs/${jobId}`)} />
              </Layer>
            </PageStack>
          </ImportExportInternationalizationProvider>
        </ImportExportAuthGuard>
      </AuthModeProvider>
    </ApolloProvider>
  );
};
